;(function () {
  const el = document.getElementById('curator-feed-default-feed-layout')
  if (!el) {
    return
  }

  var i,
    e,
    d = document,
    s = 'script'
  i = d.createElement('script')
  i.async = 1
  i.defer = 1
  i.charset = 'UTF-8'
  i.src =
    'https://cdn.curator.io/published/ca93c293-ff5d-44b5-a01c-4bdb4f88bfaf.js'
  e = d.getElementsByTagName(s)[0]
  e.parentNode.insertBefore(i, e)
})()
